import * as React from 'react';
// import { useContext } from 'react';
import { Field, useFormikContext } from 'formik';
// import memoize from 'lodash/memoize';
// import defaultTo from 'lodash/defaultTo';
// import union from 'lodash/union';

// import { naturalSortIgnoreCase } from 'util/SortUtils';
// import type { Stream } from 'views/stores/StreamsStore';
import { Switch } from 'components/common';
import { ControlLabel, Input } from 'components/bootstrap';
import { Col } from 'security-app/components/common/FormBaseStyles';
import { FormikSelect } from 'security-app/components/common/FormikComponents';
// import StreamsContext from 'contexts/StreamsContext';
// import { defaultCompare } from 'logic/DefaultCompare';

import EventProceduresParametersForm from './EventProceduresParametersForm';

type Props = {
  savedSearches: {
    label: string;
    value: string;
  }[];
  readOnly?: boolean;
};

function SearchQueryForm({ savedSearches, readOnly = false }: Props) {
  const { values } = useFormikContext<any>();
  // const allStreams = useContext(StreamsContext);

  // const streamCategoryOptions = React.useMemo(
  //   () =>
  //     allStreams
  //       .reduce((acc: { label: string; value: string; }[], stream: Stream) => {
  //         stream.categories?.forEach((category: string) => {
  //           if (!acc.find((option: { value: string; }) => option.value === category))
  //             acc.push({ label: category, value: category });
  //         });

  //         return acc;
  //       }, [])
  //       .sort((a, b) => defaultCompare(a.value, b.value)),
  //   [allStreams],
  // );

  // const formatStreamIds = memoize(
  //   (streamIds) =>
  //     streamIds
  //       .map((streamId) => allStreams.find((s) => s.id === streamId) || streamId)
  //       .map((streamOrId) => {
  //         const stream = typeof streamOrId === 'object' ? streamOrId : { title: streamOrId, id: streamOrId };

  //         return {
  //           label: stream.title,
  //           value: stream.id,
  //         };
  //       })
  //       .sort((s1, s2) => naturalSortIgnoreCase(s1.label, s2.label)),
  //   (streamIds) => streamIds.join('-'),
  // );

  // Ensure deleted streams are still displayed in select
  // const allStreamIds = union(
  //   allStreams.map((s) => s.id),
  //   defaultTo(streams, []),
  // );
  // const formattedStreams = formatStreamIds(allStreamIds);

  return (
    <>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <Field name="use_saved_search">
          {({ field, form }) => (
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Switch
                aria-label="Use saved search"
                id="toggle_saved_search"
                data-testid="saved-search-toggle"
                checked={field.value}
                onChange={() => form.setFieldValue(field.name, !field.value)}
                disabled={readOnly}
              />
              &nbsp;Use saved search
            </div>
          )}
        </Field>
      </div>
      {values.use_saved_search ? (
        <>
          <Field name="saved_search">
            {({ field }) => (
              <FormikSelect
                field={field}
                options={savedSearches}
                matchProp="value"
                clearable={false}
                onChange={field.onChange}
                label="Select Saved Search"
                disabled={readOnly}
                menuPlacement="top"
              />
            )}
          </Field>
          <EventProceduresParametersForm viewType="search" viewId={values?.saved_search} readOnly={readOnly} />
        </>
      ) : (
        <Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch">
          <ControlLabel>Search Query</ControlLabel>
          <Field name="query" styled={{ width: '100%' }}>
            {({ field }) => (
              <Input
                id={field.name}
                name={field.name}
                placeholder="Search query"
                type="text"
                value={field.value}
                onChange={field.onChange}
                onBlur={field.onBlur}
                bsStyle={field.error && field.touched ? 'error' : null}
                disabled={readOnly}
              />
            )}
          </Field>
        </Col>
      )}
      {/* <Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch">
        <Field name="streams">
          {({ field }) => (
            <FormikMultiSelect field={field}
              options={formattedStreams}
              matchProp="label"
              multiple
              label="Streams (Optional)" />
          )}
        </Field>
        <HelpBlock>Select streams the search should include. Searches in all streams if empty.</HelpBlock>
      </Col>
      {streamCategoryOptions && streamCategoryOptions.length > 0 && (<Col $fullWidth $width="100%" $gap="0.3rem" $align="stretch">
        <Field name="stream_categories">
          {({ field }) => (
            <FormikMultiSelect field={field}
              options={streamCategoryOptions}
              matchProp="label"
              multiple
              label="Stream Categories (Optional)" />
          )}
        </Field>
        <HelpBlock>Select stream categories the search should include.</HelpBlock>
      </Col>)} */}
    </>
  );
}

export default SearchQueryForm;
